import {Component} from "@angular/core";
import {NavController, NavParams, ViewController} from "ionic-angular";
import {ProductMeta} from "../../app/classes/product_meta";

/*
 Generated class for the ProductSize page.

 See http://ionicframework.com/docs/v2/components/#navigation for more info on
 Ionic pages and navigation.
 */
@Component({
  selector: 'page-product-variation',
  template: `
    <ion-list radio-group [(ngModel)]="variation" class="popover-page">
      <ion-item *ngFor="let variation of variations; let i = index;">
        <ion-label [innerHTML]="variation.title"></ion-label>
        <ion-radio value="{{i}}" checked="false"></ion-radio>
      </ion-item>
      <ion-row>
        <ion-col>
          <button id="discard-variation" clear ion-button (click)="dismiss()">
            Abbrechen
          </button>
          <button id="confirm-variation" ion-button (click)="selectVariation()">
            Auswählen
          </button>
        </ion-col>
      </ion-row>
    </ion-list>
  `


})
export class ProductVariationPage {
  public variation : any = false;
  public variations: ProductMeta[] = [];

  constructor(public navCtrl: NavController, public viewCtrl: ViewController, public navParams: NavParams) {
    this.variations = navParams.get("variations") as any[];
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad ProductSizePage');
  }

  changeProductSize() {

  }

  selectVariation() {
    this.viewCtrl.dismiss(parseInt(this.variation));
  }

  dismiss() {
    this.viewCtrl.dismiss();
  }

}



// WEBPACK FOOTER //
// ./src/pages/product-variation/product-variation.ts